<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { goto } from '$app/navigation';
  import { page } from '$app/stores';

  import GroupCollectionAjax from '@ajax/group_collection';
  import GroupAjax from '@ajax/group';
  import Track from '@utils/track';
  import Notification from '@utils/notification';
  import Profile from '@utils/profile';
  import ComponentEvents from '@utils/component-events';
  import Text from '@components/Text.svelte';
  import MobileOptionsModal from '@components/MobileOptionsModal.svelte';

  import TileNew from '@app-components/profile/TileNew.svelte';
  import RemoveCollectionModal from '@app-components/modal/RemoveCollectionModal.svelte';
  import AddEditCollectionModal from '@app-components/modal/AddEditCollectionModal.svelte';
  import RecRequestGroupQuickStartTile from './RecRequestGroupQuickStartTile.svelte';
  import Sortable from 'sortablejs';
  const AutoScroll = Sortable.AutoScroll;
  import AddGroupModal from '@app-components/modal/AddGroupModal.svelte';
  import AddGroupOrIdeaModal from '@app-components/group_ideas/AddGroupOrIdeaModal.svelte';
  import VisibilityGuard from '@components/VisibilityGuard.svelte';

  import { getProfileStore } from '@stores/profile';
  import { getGlobalStore } from '@stores/global';
  let groupScoresStore = getProfileStore('groupScoresStore');
  let recRequestGroupStore = getGlobalStore('recRequestGroupStore');
  import { getCurrentUserStore } from '@stores/current_user';
  import CustomScroll from '@utils/custom-scroll';

  try {
    Sortable.mount(new AutoScroll());
  } catch {}

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let id;
  export let user;
  export let mobile = false;

  let currentUser = getCurrentUserStore('default');

  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollection = groupCollectionStore.find(id);
  let groupCollections = groupCollectionStore;
  let groups = [];
  let groupScores = groupScoresStore;
  let recRequestGroup = recRequestGroupStore;

  let seenGroups = [];
  let seenInterval;

  let showRemoveCollectionModal = false;
  let showAddEditCollectionModal = false;
  let showOptionsMenu = false;
  let showAddGroup = false;
  let showAddGroupOrIdea = false;

  let addEditCollectionId;

  let deleteCollection;
  let deletingCollection = false;

  let addGroupTileConditions = function () {
    groupCollection &&
      groups &&
      (!groupCollection.default_collection || groupCollections.length === 1) &&
      groups.length === 0;
  };

  $: showAddGroupTile =
    groupCollection &&
    groups &&
    (!groupCollection.default_collection || groupCollections.length === 1) &&
    groups.length === 0;

  $: hasGroupIdeasUser = currentUser && currentUser.has_group_possible_ideas;

  let openOptionsMenu = function () {
    showOptionsMenu = true;
  };

  let openAddEditCollectionModal = function (edit = false) {
    addEditCollectionId = edit ? groupCollection.id : null;
    showAddEditCollectionModal = true;
  };

  let setGroupsFromStore = function () {
    if (groupsStore.length > 0 && groupCollection) {
      showAddGroupTile = addGroupTileConditions();
      let sortIds = {};
      let excludeIds = undefined;

      groupCollection.group_base_sort_order.forEach((x) => (sortIds[x] = true));

      groups = groupsStore
        .withSortOrder(groupCollection.group_base_sort_order)
        .filter((g) => sortIds[g.id] || (excludeIds && excludeIds[g.id] === undefined));
    } else {
      groups = [];
    }
  };

  let updateCollection = async function (data) {
    try {
      groupCollection.set(await GroupCollectionAjax.update(groupCollection, data));

      groupCollectionStore.runCallbacks();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
        groupCollection = groupCollection;
      }
    }
  };

  let addGroup = function () {
    if (hasGroupIdeasUser && groupsStore.length === 0) {
      showAddGroupOrIdea = true;
      return;
    }

    if (mobile) {
      showAddGroup = true;
    } else {
      createGroup({ name: 'My new list' });
    }
  };

  let createGroup = async function (data) {
    try {
      let group = await GroupAjax.create({
        ...data,
        group_collection_id: groupCollection.id,
      });

      dispatch('added-group', { group: group, collection: groupCollection });
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let checkIntersectsCollectionBar = function (evt) {
    var selectedCollectionId;

    jQuery('[data-collection-bar-id]').each(function () {
      var elem = jQuery(this);
      var top = elem.offset().top - jQuery(window).scrollTop();
      var left = elem.offset().left;
      var height = elem.outerHeight(true);
      var width = elem.outerWidth(true);
      var x = evt.originalEvent.clientX;
      var y = evt.originalEvent.clientY;
      if (y >= top && y <= top + height && x >= left && x <= left + width) {
        selectedCollectionId = elem.data('collection-bar-id');
        return;
      }
    });

    return selectedCollectionId;
  };

  let sortFinished = function (evt) {
    let fromCollectionId = jQuery(evt.from).data('group-collection-id');
    let toCollectionId = jQuery(evt.to).data('group-collection-id');

    let fromGroupIds = Profile.sortOrderByPageIds(fromCollectionId);
    let toGroupIds = Profile.sortOrderByPageIds(toCollectionId);

    let fromCollection = groupCollectionStore.find(fromCollectionId);

    fromCollection.set({
      ...fromCollection,
      group_base_sort_order: fromGroupIds,
    });

    let data = [
      {
        collection_id: fromCollectionId,
        group_ids: fromGroupIds,
      },
    ];

    if (fromCollectionId != toCollectionId) {
      data.push({
        collection_id: toCollectionId,
        group_ids: toGroupIds,
      });

      let toCollection = groupCollectionStore.find(toCollectionId);

      toCollection.set({
        ...toCollection,
        group_base_sort_order: toGroupIds,
      });
    }

    GroupCollectionAjax.updateSortOrder(user, data);
  };

  let removeCollection = async function () {
    if (groupsStore.findByIds(groupCollection.group_base_sort_order).length === 0) {
      if (deletingCollection === false) {
        deletingCollection = true;
        await deleteCollection();
        deletingCollection = false;
      }
    } else {
      displayRemoveCollectionModal();
    }
  };

  let setupSortable = function (node) {
    if (mobile || !user.permissions.edit) {
      return;
    }

    new Sortable(node, {
      group: 'profiletiles-new',
      handle: '.draggable-tile',
      forceFallback: true,
      fallbackOnBody: true,
      filter: '.undraggable',
      fallbackTolerance: 5,
      scrollSensitivity: 120,
      scrollSpeed: 20,
      scroll: true,
      onMove: (event) => {
        return !event.related.classList.contains('undroppable');
      },
      onStart: (evt) => {
        ComponentEvents.trigger('profile-collection-bar-group-sorting', {
          groupSorting: true,
        });

        jQuery(evt.item).children('.tile-container').hide();
        jQuery(evt.item).children('.draggable-placeholder').show();
        jQuery('.add-group-tile').hide();
      },
      onEnd: (evt) => {
        ComponentEvents.trigger('profile-collection-bar-group-sorting', {
          groupSorting: false,
        });

        jQuery(evt.item).children('.tile-container').show();
        jQuery(evt.item).children('.draggable-placeholder').hide();
        jQuery('.add-group-tile').show();

        var intersectedCollectionId = checkIntersectsCollectionBar(evt);

        if (intersectedCollectionId) {
          evt.to = jQuery(`[data-group-collection-id="${intersectedCollectionId}"]`)[0];

          jQuery(evt.to).append(evt.item);
        }

        sortFinished(evt);
      },
    });
  };

  let displayRemoveCollectionModal = function () {
    showRemoveCollectionModal = true;
  };

  let groupVisible = function (el, group) {
    seenGroups.push(group);
  };

  let setIntervalSeenGroupsToServer = function () {
    seenInterval = setInterval(sendSeenGroupsToServer, 10000);
  };

  let sendSeenGroupsToServer = function () {
    if (seenGroups.length == 0 || !currentUser || !currentUser.id) {
      return;
    }

    let ids = seenGroups.map((x) => x.id);
    Track.profileGroupsViewed({ currentUser, groupIds: ids, profileUserId: user.id });
    seenGroups = [];
  };

  setGroupsFromStore();

  let mobileOptions = [];

  let initializeMobileOptions = function () {
    let shareOption = {
      label: 'Share',
      image: '<img alt="share" src="/images/options-menu/share.svg" />',
      fn: async () => {
        CustomScroll.copyCollectionLink($page, id, currentUser, user.id);
      },
    };

    if (user.permissions.edit) {
      mobileOptions = [
        {
          label: 'Edit',
          image: '<img src="/images/profile/edit.svg" />',
          fn: async () => {
            openAddEditCollectionModal(true);
          },
        },
        {
          label: 'Add list',
          image: '<img src="/images/save-button/plus.svg" />',
          fn: async () => {
            addGroup();
          },
        },
        shareOption,
        {
          label: 'Organize lists',
          image: '<img alt="reorder list" src="/images/profile/organize.svg" />',
          fn: async () => {
            goto('/profiles/list_organizer');
          },
        },
        {
          label: 'Delete',
          image: '<img src="/images/profile/trash.svg" />',
          style: 'color: #FF5567',
          fn: async (option, refresh) => {
            let oldImage = option.image;
            option.image = '<i class="fa fa-spinner fa-spin"></i>';
            refresh();
            await removeCollection();
            option.image = oldImage;
            refresh();
          },
        },
      ];
    } else {
      mobileOptions = [shareOption];
    }
  };
  onMount(() => {
    setIntervalSeenGroupsToServer();

    let unsubGroupCollection = groupCollection.subscribe((x) => {
      groupCollection = x;
      setGroupsFromStore();
    });

    let unsubGroupCollections = groupCollections.subscribe((x) => {
      groupCollections = x;
    });

    let unsubRecRequestGroup = recRequestGroup.subscribe((x) => (recRequestGroup = x));

    let unsubGroups = groupsStore.subscribe(setGroupsFromStore);

    let unsubGroupScores = groupScoresStore.subscribe((x) => {
      groupScores = x;
    });

    let unsubCurrentUser = currentUser.subscribe((x) => (currentUser = x));
    initializeMobileOptions();
    return () => {
      unsubGroupCollection();
      unsubGroupCollections();
      unsubRecRequestGroup();
      unsubGroups();
      unsubGroupScores();
      unsubCurrentUser();
      sendSeenGroupsToServer();
      if (seenInterval) {
        clearInterval(seenInterval);
      }
    };
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.draggable-placeholder) {
    border: 2px dashed #aaa;
    background: #eee;
    opacity: 0.5;
    height: 240px;
    width: 100%;
    border-radius: 15px;
    display: none;
  }

  * :global(.draggable-placeholder-cover-images) {
    height: 386px;
  }

  * :global(.new-profile-tile) {
    border: 2px solid #a893f9 !important;
    border-radius: 15px;
    overflow: hidden;
  }

  .add-group-tile {
    border: 1px solid #eae4ff;
    height: 235px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      border-color: #a893f9;
      background-color: #eae4ff;
      cursor: pointer;
      > svg > path {
        fill: #a893f9;
        path: #a893f9;
      }
    }
  }

  .draggable-groups {
    display: grid;
    grid-template-columns: repeat(3, 320px);
    grid-gap: 20px;
    margin-top: 24px;
    min-height: 235px;

    .group-container {
      border-radius: 15px;
      border: 2px solid transparent;
      height: 100%;
    }
  }

  .collection-header {
    position: relative;
    margin-left: -20px;
    padding-left: 20px;

    .ui-actions {
      position: absolute;
      left: -80px;
      top: -10px;
      z-index: 4;
      justify-content: right;
      transition: all 0.25s !important;
      opacity: 0;
      width: 89px;
      display: flex;
      gap: 5px;

      .remove-btn {
        background: #f3f1f9;
        border-color: #f3f1f9;
        transition: 0.25s;
        width: 42px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;

        &:hover {
          background: #ff5567;
          border-color: #ff5567;

          svg {
            fill: white;
          }
        }
      }

      .copy-link:hover {
        cursor: pointer;
      }

      .copy-link {
        background: #f3f1f9;
        border-color: #f3f1f9;
        transition: 0.25s;
        width: 42px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;

        &:hover {
          border-color: #a893f9;
          background: #a893f9;

          svg {
            stroke: white;
            fill: white;
          }
        }
      }
    }

    .name-and-length-container {
      width: 100%;
      margin-top: 48px;
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 20px;
    }

    &:hover {
      .ui-actions {
        opacity: 1;
      }
    }
  }

  @media only screen and (max-width: 1170px) {
    .draggable-groups {
      grid-template-columns: repeat(2, 320px);
    }
  }

  .mobile {
    .no-collections-draggable-groups {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
    }

    .draggable-groups {
      overflow-x: auto;
      margin-left: -40px;
      padding-left: 40px;
      width: calc(100% + 70px);
      margin-top: 0px;
      margin-bottom: -40px;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-right: 40px;
    }

    .name-and-length-container {
      margin-top: 38px;
    }

    @media only screen and (max-width: 376px) {
      .with-collections-draggable-groups {
        margin-left: -55px;
      }
    }
  }
</style>

<RemoveCollectionModal
  mobile={mobile}
  bind:showModal={showRemoveCollectionModal}
  bind:deleteCollection={deleteCollection}
  groupCollectionId={groupCollection?.id} />

{#if showAddEditCollectionModal}
  <AddEditCollectionModal
    mobile={mobile}
    bind:showModal={showAddEditCollectionModal}
    collectionId={addEditCollectionId} />
{/if}

{#if showAddGroupOrIdea}
  <AddGroupOrIdeaModal
    mobile={mobile}
    currentUser={currentUser}
    bind:showModal={showAddGroupOrIdea}
    on:create-group={(e) => {
      createGroup(e.detail);
    }} />
{/if}

{#if showAddGroup}
  <AddGroupModal
    mobile={mobile}
    bind:showModal={showAddGroup}
    on:create-group={(e) => {
      createGroup(e.detail);
    }} />
{/if}

{#if mobile}
  <MobileOptionsModal bind:showModal={showOptionsMenu} options={mobileOptions} />
{/if}

<div class:mobile={mobile} id="ui-collection-{id}">
  {#if !groupCollection.default_collection}
    <div style="position: relative" class="collection-header">
      <div style={deletingCollection ? 'opacity: 1;' : ''} class="ui-actions undraggable">
        {#if !mobile && user.permissions.edit}
          <button class="remove-btn" on:click|preventDefault|stopPropagation={removeCollection}>
            {#if deletingCollection}
              <i class="fa fa-spin fa-spinner" style="color: white" />
            {:else}
              <svg width="16" height="16" viewBox="0 0 16 16" fill="#ff5567" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10 0C10.5523 0 11 0.447715 11 1C11 1.55228 11.4477 2 12
                    2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15
                    4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1
                    2H4C4.55228 2 5 1.55228 5 1C5 0.447715 5.44772 0 6
                    0H10ZM3.21365 15.4616C2.84389 15.1173 2.61761 14.6462 2.58002
                    14.1423L2.02721 6.40427C1.98586 5.82539 2.44433 5.33301
                    3.02467 5.33301H12.9754C13.5557 5.33301 14.0142 5.82539
                    13.9728 6.40426L13.42 14.1423C13.3824 14.6462 13.1561 15.1173
                    12.7864 15.4616C12.4166 15.8059 11.9306 15.9981 11.4254
                    15.9997H4.57468C4.06944 15.9981 3.58341 15.8059 3.21365
                    15.4616Z" />
              </svg>
            {/if}
          </button>
        {/if}

        <button
          id="copy-link-{id}"
          class="copy-link"
          on:click={() => {
            CustomScroll.copyCollectionLink($page, id, currentUser, user.id);
          }}>
          <svg fill="#a893f9" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                d="m3.10926 3.10926c.28339-.28339.66775-.44259 1.06852-.44259h5.53333c.73639 0 1.33329-.59696 1.33329-1.33334 0-.736376-.5969-1.33333-1.33329-1.33333h-5.53333c-1.10802 0-2.17065.440157-2.95414 1.22364-.783483.78349-1.22364 1.84612-1.22364 2.95414v15.64442c0 1.108.440157 2.1707 1.22364 2.9542.78349.7834 1.84612 1.2236 2.95414 1.2236h15.64442c1.108 0 2.1707-.4402 2.9542-1.2236.7834-.7835 1.2236-1.8462 1.2236-2.9542v-5.5333c0-.7364-.597-1.3333-1.3333-1.3333-.7364 0-1.3334.5969-1.3334 1.3333v5.5333c0 .4008-.1592.7851-.4426 1.0685s-.6677.4426-1.0685.4426h-15.64442c-.40077 0-.78513-.1592-1.06852-.4426s-.44259-.6677-.44259-1.0685v-15.64442c0-.40077.1592-.78513.44259-1.06852z" />
              <path
                d="m15.3872 1.63022 8.3476 6.14694c.0812.05046.1482.12027.1945.20294.0464.08268.0707.17552.0707.2699s-.0243.18722-.0707.2699c-.0463.08267-.1133.15248-.1945.20294l-8.3476 6.14696c-.3531.26-.6421.1182-.6421-.3152v-3.9404c-1.458.0053-2.8981.3159-4.2241.9112-1.32596.5952-2.50736 1.4613-3.46528 2.5406-.04973.0566-.11133.1021-.18058.1333-.06926.0311-.14456.0473-.22074.0473-.07619 0-.15148-.0162-.22074-.0473-.06926-.0312-.13086-.0767-.18059-.1333-.117-.1238-.19749-.2764-.23284-.4416s-.02422-.3368.03218-.4963c1.42872-4.25552 4.67949-7.24231 8.69269-7.24231v-3.94035c0-.43343.289-.57529.6421-.31522z" />
            </g>
          </svg>
        </button>
      </div>
      <div class="name-and-length-container">
        <div style="display: flex; flex: 1;">
          <Text
            text={user.permissions.edit
              ? groupCollection.name
              : `<h3 style="margin-top: 0px; margin-bottom: 0px; font-size: 14px; line-height: 20px;">${groupCollection.name}</h3>`}
            editable={user.permissions.edit}
            style="opacity: 1; {user.permissions.edit
              ? 'margin-right: 3px'
              : 'margin-right: 8px'}; width: unset; font-weight: 500; font-size: 14px;"
            on:blur={(e) => {
              updateCollection({ name: e.detail.text });
            }} />
          <span style="font-weight: 400; font-size: 14px; opacity: 0.5;">
            {#key groups.length}
              {groupsStore.findByIds(groupCollection.group_base_sort_order).length}
            {/key}</span>
        </div>

        {#if mobile}
          <div on:click={openOptionsMenu}>
            <img src="/images/profile/horizontal-dots.svg" />
          </div>
        {/if}
      </div>
    </div>
  {/if}

  <div
    class="draggable-groups"
    class:no-collections-draggable-groups={groupCollections.length <= 1}
    class:with-collections-draggable-groups={groupCollections.length > 1}
    class:no-scrollbar={mobile}
    style="{showAddGroupTile || groups.length > 0 ? '' : 'display: none;'} {mobile
      ? `grid-template-columns: repeat(${groups.length}, 300px);`
      : ''} {showAddGroupTile && groups.length == 0 && hasGroupIdeasUser && !mobile
      ? 'display: block; width: 320px; margin-left: auto; margin-right: auto;'
      : ''}"
    use:setupSortable
    data-group-collection-id={groupCollection.id}>
    {#if currentUser && currentUser.rec_request_group_quick_start_show && groupCollection.default_collection && recRequestGroup && recRequestGroup.total_completed == 0 && user.id === currentUser.id}
      <RecRequestGroupQuickStartTile mobile={mobile} />
    {/if}

    {#if showAddGroupTile && hasGroupIdeasUser}
      <div class="add-group-tile" on:click|preventDefault|stopPropagation={addGroup}>
        <div style="display: flex; flex-direction: column; align-items: center;">
          <img src="/images/add-rec-btn.svg" />

          {#if groupsStore.length === 0}
            <div style="margin-top: 20px; font-weight: 500; font-size: 18px; line-height: 26px;">
              Start recommending
            </div>
          {/if}
        </div>
      </div>
    {:else if showAddGroupTile}
      <div
        style={groupsStore.length === 0 ? 'background: #f9f6ff;' : ''}
        class="add-group-tile"
        on:click|preventDefault|stopPropagation={addGroup}>
        <div style="display: flex; flex-direction: column; align-items: center;">
          <img src="/images/add-rec-btn.svg" />

          {#if groupsStore.length === 0}
            <div style="margin-top: 20px; font-weight: 500; font-size: 14px; line-height: 18px;  color: #a893f9;">
              Create your first list
            </div>
          {/if}
        </div>
      </div>
    {:else}
      {#each groups as group (group)}
        <div data-group-id={group.id} class="group-container">
          <div
            class="draggable-placeholder"
            class:draggable-placeholder-cover-images={user.show_cover_photos_for_groups}>
            &nbsp;
          </div>
          <TileNew
            mobile={mobile}
            id={group.id}
            user={user}
            score={groupScores[group.id]}
            groupCollectionId={id}
            on:tile-clicked={(e) => {
              if (e.detail.event && (e.detail.event.ctrlKey || e.detail.event.metaKey)) {
                window.open(group.path);
              } else {
                goto(group.path);
              }
            }}
            on:new-duplicate-created={(e) => {
              dispatch('new-duplicate-created', { group: e.detail.group });
            }}
            on:delete-clicked={async () => {
              groupsStore.remove({ id: group.id });
              groupCollection.set({
                ...groupCollection,
                group_base_sort_order: groupCollection.group_base_sort_order.filter((x) => x != group.id),
              });
              await GroupAjax.delete(group);
            }}
            on:emoji-selected={async (e) => {
              group.set(
                await GroupAjax.update(group, {
                  emoji_id: e.detail.emoji.id,
                })
              );
            }}
            on:emoji-select-clicked={async () => {
              if (mobile) {
                goto(group.path);
              }
            }} />
          <VisibilityGuard let:hasBeenVisible>
            {#if hasBeenVisible}
              <div style="display: none" use:groupVisible={group} />
            {/if}
          </VisibilityGuard>
        </div>
      {/each}
      {#if mobile}
        <div style="width: 15px" />
      {/if}
    {/if}
  </div>
</div>
